module.exports = __webpack_public_path__ + "img/blue-screen-1.3bb96c45.webp";